<template lang="pug">
  v-container.postal-container.mt-2.pa-0(fluid)
    v-container#postal.pa-0(fluid justify-center)
      v-container.postal.px-0.mt-3.pb-0(fluid)
        v-layout.header(row wrap)
          v-flex.pb-2(d-flex xs12 sm5)
            v-layout(column)
              v-flex(d-flex xs1)
                v-card.justify-center.align-center(d-flex flat)
                  img.info(src="/static/logo.jpeg")
          v-flex.pb-2(d-flex xs12 sm7)
            v-layout(column)
              v-flex(d-flex xs12)
                .fill
                  v-flex(d-flex xs12 fill-height align-center)
                    h1.head.title {{stateVisible ? (record.synthesis.state || 'Entidad') : ''}}
                    p.head.subtitle.dark-text.pl-2.mr-3(fill-height align-center) Folio {{record.folio ? '#' + record.folio : ''}}
        v-layout.pl-3.pr-3.pt-1.location.centered(row wrap d-flex fill-height align-content-center)
          v-flex.pl-3(xs9 align-center)
            v-layout.mx-0.where(row wrap)
              v-flex.border.pl-2(d-flex xs6)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.content-title(v-if="attentionDateVisible") {{record.attention.attentionDate}}
              v-flex.border.pl-2(d-flex xs6)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.content-title {{municipalityVisible ? (record.synthesis.municipality && record.synthesis.municipality.lenght > 22 ? record.synthesis.municipality.substr(0,19) + '...' : record.synthesis.municipality) : ''}}{{municipalityVisible && record.synthesis.municipality ? ',' : ''}} {{stateVisible ? record.synthesis.state : ''}}
            v-layout.mx-0.when(row wrap)
              v-flex.pl-1(d-flex xs6)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1
                    p.info-title Fecha de atención
              v-flex.pl-2(d-flex xs6)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1
                    p.info-title Localidad / Estado
        
        v-layout.px-3.mt-0.centered(row wrap)
          v-layout.my-0(row wrap justify-space-between)
            v-flex.mx-0.where.border(xs12)
              .fill-height.align-end.text-xs-center.d-flex
                v-card-text.pt-0.pb-0
                  p.black-content-title {{matterVisible ? showSelections(record.synthesis.matter, 'Matter') : ''}}
            v-flex.mx-0.when(xs12)
              .fill-height.align-center.text-xs-center.d-flex
                v-card-text.pt-0.pb-1
                  p.info-title Asunto de la asesoría

        v-layout.px-3.mt-0(row wrap)
          v-flex.mx-0.where(xs12)
            v-layout.my-0(row wrap justify-space-between)
              v-flex.border(d-flex xs4)
                .fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{interventionVisible ? showSelections(record.synthesis.intervention, 'Intervention') : ''}}
              v-flex.border(d-flex xs4)
                .fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{referredVisible ? showSelections(record.synthesis.referred, 'Referrence') : ''}}
          v-flex.mx-0.where(xs12)
            v-layout.my-0(row wrap justify-space-between)
              v-flex(d-flex xs4)
                .fill-height.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1.px-1
                    p.info-title Intervención
              v-flex(d-flex xs4)
                .fill-height.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1.px-1
                    p.info-title Canalización

        v-layout.px-3.mt-0(row wrap)
          v-flex.mx-0.where(xs12)
            v-layout.my-0(row wrap justify-space-between)
              v-flex.border(d-flex xs4)
                .fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{municipalityVisible ? (record.synthesis.municipality && record.synthesis.municipality.lenght > 22 ? record.synthesis.municipality.substr(0,19) + '...' : record.synthesis.municipality) : ''}}{{municipalityVisible && record.synthesis.municipality ? ',' : ''}} {{stateVisible ? record.synthesis.state : ''}}
              v-flex.border(d-flex xs4)
                .fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{record.attention.initialYear}}
          v-flex.mx-0.where(xs12)
            v-layout.my-0(row wrap justify-space-between)
              v-flex(d-flex xs4)
                .fill-height.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1.px-1
                    p.info-title Lugar de ocurrencia
              v-flex(d-flex xs4)
                .fill-height.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1.px-1
                    p.info-title Año inicial del caso

        v-layout.px-3.grey-bck(row wrap)
          v-flex.mx-0.where(xs12)
            v-layout.my-0(row wrap justify-space-between)
              v-flex.border(d-flex xs2)
                .fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{ageVisible ? record.petitioner.age : ''}}
              v-flex.border(d-flex xs2)
                .fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{sexVisible ? record.petitioner.sex : ''}}
              v-flex.border(d-flex xs4)
                .fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{occupationVisible ? record.petitioner.occupation : ''}}
              v-flex.border(d-flex xs4)
                .fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{civilStatusVisible ? record.petitioner.civilStatus : ''}}
          v-flex.mx-0.where(xs12)
            v-layout.my-0(row wrap justify-space-between)
              v-flex(d-flex xs2)
                .fill-height.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1.px-1
                    p.info-title Edad
              v-flex(d-flex xs2)
                .fill-height.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1.px-1
                    p.info-title Sexo
              v-flex(d-flex xs4)
                .fill-height.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1.px-1
                    p.info-title Ocupación
              v-flex(d-flex xs4)
                .fill-height.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1.px-1
                    p.info-title Estado civil

        v-layout.px-3.note(row wrap justify-center)
          p Datos del solicitante de asesoría
        
</template>

<script>
export default {
  name: "Postal",
  props: {},
  data() {
    return {
      unselect: []
    };
  },
  computed: {
    path() {
      return this.$router.currentRoute.path;
    },
    record() {
      return this.$store.getters.record;
    },
    selection() {
      const sexualViolence = this.record.sexualViolence;
      const tortureViolence = this.record.tortureViolence;
      const wasOffenderFound = this.record.wasOffenderFound;
      let selection = [];

      if (sexualViolence == "Sí") {
        selection.push("sexualViolence-si");
      } else if (sexualViolence == "No") {
        selection.push("sexualViolence-no");
      } else if (sexualViolence == "S/D") {
        selection.push("sexualViolence-sd");
      }

      if (tortureViolence == "Sí") {
        selection.push("tortureViolence-si");
      } else if (tortureViolence == "No") {
        selection.push("tortureViolence-no");
      } else if (tortureViolence == "S/D") {
        selection.push("tortureViolence-sd");
      }

      if (wasOffenderFound == "Sí") {
        selection.push("wasOffenderFound-si");
      } else if (wasOffenderFound == "No") {
        selection.push("wasOffenderFound-no");
      } else if (wasOffenderFound == "S/D") {
        selection.push("wasOffenderFound-sd");
      }
      return selection;
    },
    attentionDateVisible() {
      return this.$store.state.record.attention.attentionDateVisible;
    },
    stateVisible() {
      return this.$store.state.record.synthesis.stateVisible;
    },
    municipalityVisible() {
      return this.$store.state.record.synthesis.municipalityVisible;
    },
    matterVisible() {
      return this.$store.state.record.synthesis.matterVisible;
    },
    interventionVisible() {
      return this.$store.state.record.synthesis.interventionVisible;
    },
    referredVisible() {
      return this.$store.state.record.synthesis.referredVisible;
    },
    ageVisible() {
      return this.$store.state.record.petitioner.ageVisible;
    },
    sexVisible() {
      return this.$store.state.record.petitioner.sexVisible;
    },
    occupationVisible() {
      return this.$store.state.record.petitioner.occupationVisible;
    },
    civilStatusVisible() {
      return this.$store.state.record.petitioner.civilStatusVisible;
    }
  },
  methods: {
    showSelections(obj) {
      let selected = [];
      Object.entries(obj).forEach(val => {
        if (val[1].isSelected) {
          selected.push(val[1].text);
        }
      });
      return selected.join(", ");
    }
  }
};
</script>

<style src="./postal.scss" lang="scss"></style>
